export default __webpack_public_path__ + "static/media/user-pics-3.25acd2c7.png";